import Module          from 'scripts/module';
import UnitFeatureSet  from 'scripts/defa/unit-feature-sets/model-unit-feature-set';
import UnitFeatureSets from 'scripts/defa/unit-feature-sets/collection-unit-feature-sets';
import Warmup          from 'scripts/defa/unit-feature-sets/endpoints/warmup/model-warmup'; 
import Warmups         from 'scripts/defa/unit-feature-sets/endpoints/warmup/collection-warmups';

const UnitFeatureSetModule = new Module( 'UnitFeatureSetModule', {
	collections: {
		UnitFeatureSets,
		Warmups
	},
	models     : {
		UnitFeatureSet,
		Warmup
	},
} );
export default UnitFeatureSetModule;